export default __webpack_public_path__ + "static/media/interviewer-comment.d7c0eac8.svg";